module.exports = __webpack_public_path__ + "img/30.31b8e531.jpg";